import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Trash20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      d='M9.24994 7.77777L9.24994 14.4444H10.7499V7.77777H9.24994Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.74994 3.75H2.5V5.25H3.82877L5.20522 17.638C5.27556 18.2711 5.81064 18.75 6.44757 18.75H13.5525C14.1895 18.75 14.7245 18.2711 14.7949 17.638L16.1713 5.25H17.5V3.75H12.7499C12.7499 2.7706 12.6009 1.85829 11.8713 1.12868C10.7158 -0.0267373 8.78403 -0.026738 7.62862 1.12868C6.899 1.85829 6.74994 2.7706 6.74994 3.75ZM8.68928 2.18934C8.25088 2.62774 8.24994 3.17675 8.24994 3.75H11.2499C11.2499 3.17675 11.249 2.62774 10.8106 2.18934C10.2329 1.61163 9.26698 1.61163 8.68928 2.18934ZM14.6621 5.25H5.338L6.67133 17.25H13.3288L14.6621 5.25Z'
      fill='currentColor'
    />
  </Svg>
);

Trash20.displayName = 'Trash20';
export default Trash20;
